module.exports = __webpack_public_path__ + "static/media/IIIBDS.62165fa4.pdf";